var _a, _b, _c, _d;
import { createTheme } from '@mui/material/styles';
import { red } from '@mui/material/colors';
export var Colors = {
    AZUL_GOV: '#034EA2',
    AMARELO_GOV: '#FDB913',
    VERMELHO_GOV: '#EF4123',
    VERDE_GOV: '#007932',
    /** Novo padrão do Design System (botões/ações primárias) */
    AZUL_DS: '#0048B6',
};
export var MOBILE_SIZE = 768;
export var theme = createTheme({
    palette: {
        primary: {
            main: Colors.AZUL_DS,
        },
        secondary: {
            main: '#19857b',
        },
        error: {
            main: red.A400,
        },
    },
    typography: {
        fontFamily: [
            'Roboto',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        subtitle1: (_a = {
                fontSize: '1rem',
                marginBottom: '1rem'
            },
            _a["@media (max-width: ".concat(MOBILE_SIZE, "px)")] = {
                fontSize: '0.875rem',
            },
            _a),
        body2: (_b = {
                fontSize: '0.875rem'
            },
            _b["@media (max-width: ".concat(MOBILE_SIZE, "px)")] = {
                fontSize: '0.75rem',
            },
            _b),
        h4: (_c = {
                fontSize: '2.125rem',
                marginBottom: '1rem'
            },
            _c["@media (max-width: ".concat(MOBILE_SIZE, "px)")] = {
                fontSize: '1.25rem',
            },
            _c),
        h6: (_d = {
                fontSize: '1.25rem',
                marginBottom: '1rem'
            },
            _d["@media (max-width: ".concat(MOBILE_SIZE, "px)")] = {
                fontSize: '1rem',
            },
            _d),
    },
    zIndex: {
        appBar: 2000,
        drawer: 1900,
        modal: 1800,
        snackbar: 1700,
        tooltip: 1600,
    },
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    borderRadius: '14px',
                    background: '#FFFFFF',
                    borderWidth: 1,
                    borderColor: '#ECEEF4',
                    boxShadow: 'none',
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (_b = {
                            minHeight: 'unset'
                        },
                        _b[theme.breakpoints.down(MOBILE_SIZE)] = {
                            height: '48px',
                            minHeight: '48px',
                            width: '100%'
                        },
                        _b);
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: function (_a) {
                    var _b;
                    var theme = _a.theme;
                    return (_b = {
                            overflow: 'auto',
                            maxWidth: '100%',
                            width: '100%',
                            bgcolor: '#ffffff',
                            borderRadius: 8,
                            boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
                        },
                        _b[theme.breakpoints.up(MOBILE_SIZE)] = {
                            padding: '1.8rem',
                            overflow: 'auto',
                            maxWidth: '100%',
                            width: '100%',
                            marginTop: '16px',
                            marginBottom: '20px',
                        },
                        _b[theme.breakpoints.down(MOBILE_SIZE)] = {
                            padding: '1.5rem',
                            overflow: 'auto',
                            maxWidth: '100%',
                            width: '100%',
                            marginTop: '8px',
                            marginBottom: '15px',
                        },
                        _b);
                },
            },
        }
    },
});
